<template>
  <ac-modal :model-value="isOpen" mobile-modal-type="bottomSheet" @update:modelValue="onBackdrop">
    <continue-in-app-content v-if="variant === 'continue_in_app'" @close="onClose" @cta="close" />
    <setup-reminders-content v-else-if="variant === 'setup_reminders'" @close="onClose" @cta="close" />
  </ac-modal>
</template>

<script lang="ts" setup>
import { watch, onMounted } from 'vue'
import { useMq } from 'vue3-mq'

import AcModal from '@ui-kit/components/AcModal.vue'
import { postFirstDayModalShown, postFirstDayModalClosed } from '@web/services/Analytics/events'
import type { CloseMethod } from '@web/services/Analytics/events/postFirstDayModal'
import { usePostFirstDayModal } from '@web/platform.v3/composables/usePostFirstDayModal'
import ContinueInAppContent from './ContinueInAppContent.vue'
import SetupRemindersContent from './SetupRemindersContent.vue'

const { isOpen, variant, close, showIfPending } = usePostFirstDayModal()
const mq = useMq()

// Вход в ЛК на любой странице: если модалка запланирована (вкладку закрыли, не показав) — показываем.
onMounted(() => {
  showIfPending()
})

function platformView (): 'mobile_web' | 'desktop_web' {
  return mq.current === 'desktop' ? 'desktop_web' : 'mobile_web'
}

// Событие показа — при открытии модалки
watch(isOpen, (open) => {
  if (open && variant.value) {
    postFirstDayModalShown({ modalType: variant.value, platformView: platformView() })
  }
})

function onClose (method: CloseMethod): void {
  if (variant.value) {
    postFirstDayModalClosed({ modalType: variant.value, closeMethod: method, platformView: platformView() })
  }
  close()
}

// Клик по бэкдропу (AcModal шлёт update:modelValue=false) — трактуем как закрытие крестиком
function onBackdrop (value: boolean): void {
  if (!value) onClose('cross_button')
}
</script>
